import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
	{
		path: '',
		component: () => import('@/views/conti/Conti.vue'),
		meta: {
			title: 'conti',
			acl: 'section.conti'
		}
	}
];

export default routes;